exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrap-name[data-v-3eb55a4c]{display:flex;flex:1}.wrap-name[data-v-3eb55a4c],.wrap-name .intv-name[data-v-3eb55a4c]{white-space:nowrap;overflow:hidden}.wrap-name .intv-name[data-v-3eb55a4c]{text-overflow:ellipsis}.disabledBg[data-v-3eb55a4c]{background-color:#fff}", ""]);

// exports
